import { Country, ParcelStatus, Theme } from "@/enums";

export const isGroundGeo = (theme: Theme, fromCountryId: Country) => {
  if (theme === Theme.GEORGIA) {
    return (
      fromCountryId === Country.GREECE ||
      fromCountryId === Country.CHINA_LAND ||
      fromCountryId === Country.TURKEY
    );
  }
  return false;
};

// for: delivery type, additional-services
export const nonEditableStatusesForDeliveryTypeAndServices = [
  // ParcelStatus.COMMON_STATUS_PROCESSED_AT_THE_INSTOCK,
  ParcelStatus.COMMON_STATUS_PREPARED_SHIPPING_FROM_FCOUNTRY,
  ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY,
];

export const nonEditableStatusesForCountryAndTrackingCode = [
  ParcelStatus.COMMON_STATUS_RECEIVED_AT_THE_INSTOCK,
  ParcelStatus.COMMON_STATUS_PROCESSED_AT_THE_INSTOCK,
  ParcelStatus.COMMON_STATUS_PREPARED_SHIPPING_FROM_FCOUNTRY,
  ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY,
];

export const declarationRequiredStatusses = [
  ParcelStatus.COMMON_STATUS_PROCESSED_AT_THE_INSTOCK,
  ParcelStatus.COMMON_STATUS_PREPARED_SHIPPING_FROM_FCOUNTRY,
  ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY,
];
